import { useEffect, useMemo } from "react"

import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import { tooltipLine } from "../../DashboardPage/components/chartsPlagins"
import { HOME_CHART } from "../redux/home.constants"
import {
  selectHomeChartFilters,
  selectHomeDeflectedChart,
  selectHomeDeflectedChartFetching,
  setChartFilters
} from "../redux/home.slice"
import {
  buildComparisonOverlay,
  buildPrimaryDataset,
  homeChartOptions
} from "../utils/chartOptions"
import HomeChartCard from "./HomeChartCard"

const SEGMENTS = [
  { value: "count", label: "Count" },
  { value: "volume", label: "Volume" }
]

// Unlike the rate chart, the toggle here is a query parameter: the endpoint sends one series, in
// the unit that was asked for, so a flip is a new request rather than a second series in hand.
const DeflectedChart = ({ getChartData }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { mode } = useSelector(selectHomeChartFilters(HOME_CHART.DEFLECTED))
  const deflected = useSelector(selectHomeDeflectedChart)
  const fetching = useSelector(selectHomeDeflectedChartFetching)
  const theme = useSelector((state) => state.nav.theme)

  useEffect(() => {
    getChartData({ chart_type: mode })
  }, [getChartData, mode])

  const isVolume = mode === "volume"

  const data = useMemo(() => {
    const labels = deflected?.labels ?? []
    const comparison = deflected?.comparison

    return {
      labels,
      datasets: [
        buildPrimaryDataset({
          label: t("Chargebacks deflected"),
          data: deflected?.result?.data ?? [],
          pointCount: labels.length
        }),
        ...buildComparisonOverlay({
          labels,
          series: comparison?.result?.data,
          comparisonLabels: comparison?.labels,
          label: deflected?.comparison_period?.label || t("previous period")
        })
      ]
    }
  }, [deflected, t])

  const options = useMemo(
    () => homeChartOptions({ theme, title: t("Chargebacks deflected"), isCurrency: isVolume }),
    [theme, isVolume, t]
  )

  return (
    <HomeChartCard
      testId="home-chart-deflected"
      icon="card"
      title="Chargebacks deflected"
      segments={SEGMENTS}
      activeSegment={mode}
      onSegmentChange={(value) =>
        dispatch(setChartFilters({ chart: HOME_CHART.DEFLECTED, filters: { mode: value } }))
      }
      data={data}
      options={options}
      plugins={[tooltipLine]}
      loading={fetching}
    />
  )
}

export default DeflectedChart
